import { Calendar } from "lucide-react";
import { formatWorkspacePrice } from "~/utils/workspace/currency";
import { useQuery } from "@tanstack/react-query";
import { CategoryItem } from "~/.server/api/routers/workspace";

type WorkspaceRentalTypeDisplayProps = {
  rentalTypes: Array<{
    slug: string;
    priceMin: number;
    priceMax: number;
    currency: string;
  }>;
};

export function WorkspaceRentalTypesDisplay({ 
  rentalTypes 
}: WorkspaceRentalTypeDisplayProps) {
  const { data: allRentalTypes } = useQuery<CategoryItem[]>({ 
    queryKey: ['rentalTypes'] 
  });

  if (!rentalTypes || rentalTypes.length === 0) {
    return null;
  }

  // Create a map of rental type slugs to labels
  const rentalTypeLabels = Object.fromEntries(
    allRentalTypes?.map(type => [type.value, type.label]) || []
  );
  
  return (
    <div className="flex items-start gap-2">
      <Calendar className="h-5 w-5 text-muted-foreground mt-0.5" />
      <div>
        <p className="font-semibold">Tipo de alquiler</p>
        <ul className="space-y-1 mt-1">
          {rentalTypes.map((type, index) => {
            const typeLabel = rentalTypeLabels[type.slug] || 
                             type.slug.replace(/-/g, ' ');
            
            const formattedPrice = formatWorkspacePrice(type.priceMin, type.currency);
            
            const priceRange = type.priceMax !== type.priceMin ? 
              ` - ${formatWorkspacePrice(type.priceMax, type.currency)}` : 
              "";
              
            return (
              <li key={`${type.slug}-${index}`} className="text-sm text-muted-foreground">
                <span className="capitalize">{typeLabel}</span>: {formattedPrice}{priceRange}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
